<template lang="pug">
  .task-grid(v-platform-expose="handleChannelExpose")
    //- 使用 quark-shopping-cashback 组件，隐藏 header 和 banner，仅展示宫格+粘贴板
    quark-shopping-cashback(
      ref="cashbackRef"
      page-id="Welfare"
      scene-name-en="platform_points"
      sub-scene-name-en="pp_order_coin_back"
      :env="mobileEnv"
      scene="rebateBonus"
      auxo-grid-module-key="welfare"
      :use-cache="false"
      :use-new-ui="true"
      :style-version="styleVersion"
      :adaptive-width="true"
      :takeout-test-version="takeoutTestVersion"
      use-external-data-source
      @emitevent="handleEmit"
    )
      //- 隐藏 header
      div(slot="header")
      //- 隐藏 banner
      div(slot="banner")
      //- 隐藏粘贴板标题
      div(slot="clipboardTitle")
</template>

<script>
// TODO: 数据改为外部传入，通过 externalChannels 传给 quark-shopping-cashback
import '@hb/generate-income-components';
import config from '@/const/config';
import { ParamsUtil } from '@/utils/params';
import { adaptChannelData } from '../../utils';
import { getRebateModuleKey } from '../../common/task';
import SPM from '../../common/spm';

export default {
  name: 'TaskGrid',
  props: {
    // TODO: 外部传入的宫格数据（ECommerceChannelInfo 格式）
    channelList: {
      type: Array,
      default: () => [],
    },
    styleVersion: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mobileEnv: config.env === 'dev' ? 'fat' : config.env,
    };
  },
  computed: {
    externalChannels() {
      return (this.channelList || []).map(adaptChannelData);
    },
    // 电商返佣实验版本（埋点字段 takeoutTestVersion）
    takeoutTestVersion() {
      return getRebateModuleKey();
    },
  },
  mounted() {
    // 必须在 componentDidMount 之前赋值，否则组件内部会自己发请求
    if (this.externalChannels?.length) {
      this.$refs.cashbackRef.externalChannels = this.externalChannels;
    }
  },
  methods: {
    handleEmit(e) {
      if (e.detail.type === 'loaded') {
        this.$emit('loaded');
      }
      if (e.detail.type === 'cashback') {
        this.$emit('bounty');
      }
    },
    // 宫格容器曝光：遍历上报每个宫格的 Welfare_purchase_task_channel 曝光
    handleChannelExpose() {
      const adsource = ParamsUtil.getParam('adsource') || '';
      this.externalChannels.forEach((item, index) => {
        SPM.moduleExpose({
          moduleId: 'Welfare_purchase_task_channel',
          contentId: 'Welfare_purchase_task_channel',
          exposureTimes: 1,
          businessInfo: {
            clk_url: item?.link || item?.originUrl || '',
            adsource,
            takeoutTestVersion: this.takeoutTestVersion,
            buyicon_name: item?.gridName || '',
            rankNum: index + 1,
          },
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.task-grid {
  overflow: hidden;
  width: 3.39rem;
  padding-left: 0.4rem;
  margin-top: 0.025rem;

  --clipboard-padding-left: 5px;
  --clipboard-padding-right: 12px;
}
</style>
